export type MentionableUser = {
    readonly id: number | string;
    readonly fullName: string;
    readonly isSelectable: boolean;
};

export const filterMentionableUsers = <T extends MentionableUser>(
    users: ReadonlyArray<T>,
    query: string
): ReadonlyArray<T> => {
    const needle = query.trim().toLowerCase();

    return users.filter((user) => {
        if (!user.isSelectable) {
            return false;
        }

        return !needle || user.fullName.toLowerCase().includes(needle);
    });
};
